import React from 'react';
import cx from 'classnames';
import moment from 'moment-timezone';

import { CircleIcon, FontAwesomeIcon } from '@magoosh/lib/icons';
import { pluralize } from 'utilities/pluralize';
import { minutesFormattedasHoursAndMinutesString } from 'utilities/time';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  createdAt: number;
  name: string;
  promptCount: number;
  timeInSeconds: number;
}

export default (props: Props) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  return (
    <div className="align-items-center d-flex gap-m">
      <div className="flex-none">
        {(() => {
          const greenPalette = { dark: colors.green, light: colors.greenLight };
          const orangePalette = { dark: colors.brandWarning, light: '#FFD9B4' };
          const purplePalette = { dark: colors.purple, light: colors.purpleLight };

          if (props.name == 'Official Questions') {
            return (
              <CircleIcon bordered colorPalette={purplePalette} size={55}>
                <FontAwesomeIcon icon="edit" style={{ fontSize: 24 }} />
              </CircleIcon>
            );
          } else if (props.name == 'Practice Test') {
            return (
              <CircleIcon bordered colorPalette={purplePalette} size={55}>
                <FontAwesomeIcon icon="edit" style={{ fontSize: 24 }} />
              </CircleIcon>
            );
          } else if (props.name == 'Diagnostic Quiz') {
            return (
              <CircleIcon bordered colorPalette={purplePalette} size={55}>
                <FontAwesomeIcon icon="edit" style={{ fontSize: 24 }} />
              </CircleIcon>
            );
          } else if (props.name.startsWith('Lesson Drills')) {
            return (
              <CircleIcon bordered colorPalette={orangePalette} size={55}>
                <FontAwesomeIcon icon="bolt" style={{ fontSize: 24 }} />
              </CircleIcon>
            );
          } else {
            return (
              <CircleIcon bordered colorPalette={greenPalette} size={55}>
                <FontAwesomeIcon icon="map-o" style={{ fontSize: 24 }} />
              </CircleIcon>
            );
          }
        })()}
      </div>

      <div className="d-flex flex-column gap-xxs">
        <h2 className={cx(style.title, 'u-margin-A-n')}>
          <strong>{props.name}</strong>
        </h2>

        <div className="small">
          <span className="text-underdash">
            {moment(props.createdAt * 1000).tz(timeZone).format('MMMM D')}
          </span>
          {' '}•{' '}
          <span className="text-underdash">
            {pluralize(props.promptCount, 'question')}
          </span>
          {' '}•{' '}
          <span className="text-underdash">
            {minutesFormattedasHoursAndMinutesString(props.timeInSeconds / 60)}
          </span>
        </div>
      </div>
    </div>
  );
};
